<template>
  <div class="flex flex-col items-center justify-center gap-2">
    <Button
      :loading="loading && continuer === null"
      severity="secondary"
      @click="onSubmitLogin"
      >S'identifier avec Bitrix24
    </Button>
    <span v-if="loading">Verification en cours...</span>
  </div>
</template>

<script setup>
import { createAuth0Client } from "@auth0/auth0-spa-js";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import Button from "primevue/button";
import { ref, defineProps, defineEmits } from "vue";
import jwt_decode from "jwt-decode";
import { BITRIX_CONNEXION } from "@/config/societes";

const store = useStore();
const route = useRoute();
const router = useRouter();
const loading = ref(false);
const continuer = ref(null);

const props = defineProps(["mode"]);
const emit = defineEmits(["success"]);

if (route.query.code && route.query.state) {
  loading.value = true;

  const urlParams = new URLSearchParams(route.query);
  fetch(process.env.VUE_APP_API_URL + "/check?" + urlParams.toString(), {
    headers: {
      "x-domain": BITRIX_CONNEXION.societe,
    },
  })
    .then((res) => res.json())
    .then((response) => {
      const user = jwt_decode(response.access_token);
      store.commit("setAuth", {
        access_token: response.access_token,
        expires_in: response.expires_in,
        user,
      });

      // À défaut de sélection persistée, on bascule sur la société de l'utilisateur.
      if (!localStorage.getItem("selected_societe")) {
        store.commit("domain/setSelectedSociete", user?.societe);
      }

      if (store.getters.getRedirectUrl) {
        continuer.value = store.getters.getRedirectUrl;
        router.push({ path: store.getters.getRedirectUrl });
      } else {
        continuer.value = "/vehicules";
        router.push({ path: "/vehicules" });
      }
    })
    .catch((error) => {
      loading.value = false;
    })
    .then(() => {
      loading.value = false;
    });
}

const onSubmitLogin = async () => {
  const auth0Client = await createAuth0Client({
    domain: BITRIX_CONNEXION.domain,
    clientId: BITRIX_CONNEXION.clientId,
  });

  if (props.mode === "redirect") {
    auth0Client.loginWithRedirect();
  } else {
    await auth0Client.loginWithPopup();
    emit("success");
  }
};
</script>
